import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export const urlInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const isLocalRequest = req.url.includes('assets');

  if (isLocalRequest) {
    return next(req);
  }

  const modifiedRequest = req.clone({
    url: `${environment.apiUrl}${req.url}`,
  });

  return next(modifiedRequest);
};
